import React, { useState } from 'react'
import { Card, CardHeader, CardContent, Collapse, IconButton, makeStyles } from '@material-ui/core'
import { ExpandMoreOutlined } from '@material-ui/icons'
import clsx from 'clsx'
import { gray } from '../../utils/colors'

const useStyles = makeStyles((theme) => ({
	header: {
		padding: '13px 24px',
		userSelect: 'none',
		cursor: 'pointer',
		'& .MuiCardHeader-action': {
			margin: 0
		}
	},
	expand: {
		transform: 'rotate(0deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest
		}),
		padding: 0
	},
	expandOpen: {
		transform: 'rotate(180deg)'
	},
	grid: {
		display: 'grid',
		gridGap: '23px',
		marginBottom: '23px',
		gridTemplateColumns: 'repeat(auto-fill, minmax(424px, 1fr))',
		'& .field-wrapper': {
			marginBottom: 0
		}
	},
	fieldWrapper: {
		'& .MuiTextField-root': {
			minWidth: '424px !important'
		},
		marginBottom: '23px'
	},
	autoComplete: {
		'& .MuiFilledInput-root': {
			paddingTop: '17px'
		},
		'& .Mui-focused': {
			'& .MuiAutocomplete-endAdornment svg': {
				fill: theme.palette.secondary.main
			}
		},
		'& .MuiAutocomplete-endAdornment svg': {
			fill: gray[700]
		}
	}
}))

const StyledCollapsibleCard = ({ title, children, onExpanded, onCollapsed }) => {
	const classes = useStyles()

	const [isExpanded, setIsExpanded] = useState(false)

	const handleCollapse = () => {
		if (!isExpanded) {
			setIsExpanded(true)
			if (onExpanded) {
				onExpanded()
			}
		} else {
			setIsExpanded(false)
			if (onCollapsed) {
				onCollapsed()
			}
		}
	}

	return (
		<Card>
			<CardHeader
				className={classes.header}
				title={title}
				onClick={handleCollapse}
				action={
					<IconButton
						className={clsx(classes.expand, { [classes.expandOpen]: isExpanded })}
						onClick={handleCollapse}
						aria-expanded={isExpanded}
						aria-label="show more">
						<ExpandMoreOutlined style={{ fill: gray[700] }} />
					</IconButton>
				}
			/>
			<Collapse in={isExpanded} timeout="auto" unmountOnExit>
				<CardContent>{children}</CardContent>
			</Collapse>
		</Card>
	)
}

export default StyledCollapsibleCard
